/* @generated from adl module ferovinum.app.dtos */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as ferovinum_app_db from './db';

/**
 * API DTO for getting ProductStockDetail objects 
 */
export interface GetProductStockDetailDto {
  ref: ferovinum_app_db.ProductStockDetailRef;
  batchNumber: (string|null);
  bestBeforeDate: (common.LocalDate|null);
  rotationNumber: (string|null);
  rotationLine: (string|null);
  quantity: common.BigDecimal;
}

export function makeGetProductStockDetailDto(
  input: {
    ref: ferovinum_app_db.ProductStockDetailRef,
    batchNumber: (string|null),
    bestBeforeDate: (common.LocalDate|null),
    rotationNumber: (string|null),
    rotationLine: (string|null),
    quantity: common.BigDecimal,
  }
): GetProductStockDetailDto {
  return {
    ref: input.ref,
    batchNumber: input.batchNumber,
    bestBeforeDate: input.bestBeforeDate,
    rotationNumber: input.rotationNumber,
    rotationLine: input.rotationLine,
    quantity: input.quantity,
  };
}

const GetProductStockDetailDto_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.dtos","decl":{"annotations":[{"value":"API DTO for getting ProductStockDetail objects \n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"ref","default":{"kind":"nothing"},"name":"ref","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ProductStockDetailRef"}},"parameters":[]}},{"annotations":[],"serializedName":"batchNumber","default":{"kind":"nothing"},"name":"batchNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"bestBeforeDate","default":{"kind":"nothing"},"name":"bestBeforeDate","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}]}},{"annotations":[],"serializedName":"rotationNumber","default":{"kind":"nothing"},"name":"rotationNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"rotationLine","default":{"kind":"nothing"},"name":"rotationLine","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"quantity","default":{"kind":"nothing"},"name":"quantity","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}}]}},"name":"GetProductStockDetailDto","version":{"kind":"nothing"}}};

export const snGetProductStockDetailDto: ADL.ScopedName = {moduleName:"ferovinum.app.dtos", name:"GetProductStockDetailDto"};

export function texprGetProductStockDetailDto(): ADL.ATypeExpr<GetProductStockDetailDto> {
  return {value : {typeRef : {kind: "reference", value : snGetProductStockDetailDto}, parameters : []}};
}

/**
 * API DTO for including in Purchase Request Line Items to indicate the stock detail for a product
 */
export interface SaveProductStockDetailDto {
  batchNumber: (string|null);
  bestBeforeDate: (common.LocalDate|null);
  rotationNumber: (string|null);
  rotationLine: (string|null);
  quantity: common.BigDecimal;
}

export function makeSaveProductStockDetailDto(
  input: {
    batchNumber: (string|null),
    bestBeforeDate: (common.LocalDate|null),
    rotationNumber: (string|null),
    rotationLine: (string|null),
    quantity: common.BigDecimal,
  }
): SaveProductStockDetailDto {
  return {
    batchNumber: input.batchNumber,
    bestBeforeDate: input.bestBeforeDate,
    rotationNumber: input.rotationNumber,
    rotationLine: input.rotationLine,
    quantity: input.quantity,
  };
}

const SaveProductStockDetailDto_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.dtos","decl":{"annotations":[{"value":"API DTO for including in Purchase Request Line Items to indicate the stock detail for a product\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"batchNumber","default":{"kind":"nothing"},"name":"batchNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"bestBeforeDate","default":{"kind":"nothing"},"name":"bestBeforeDate","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}]}},{"annotations":[],"serializedName":"rotationNumber","default":{"kind":"nothing"},"name":"rotationNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"rotationLine","default":{"kind":"nothing"},"name":"rotationLine","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"quantity","default":{"kind":"nothing"},"name":"quantity","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}}]}},"name":"SaveProductStockDetailDto","version":{"kind":"nothing"}}};

export const snSaveProductStockDetailDto: ADL.ScopedName = {moduleName:"ferovinum.app.dtos", name:"SaveProductStockDetailDto"};

export function texprSaveProductStockDetailDto(): ADL.ATypeExpr<SaveProductStockDetailDto> {
  return {value : {typeRef : {kind: "reference", value : snSaveProductStockDetailDto}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.app.dtos.GetProductStockDetailDto" : GetProductStockDetailDto_AST,
  "ferovinum.app.dtos.SaveProductStockDetailDto" : SaveProductStockDetailDto_AST
};
